import React from "react";
import { Tag, Statistic, Icon, Row, Col, Popover } from "antd";
import { ProcessTrigger } from "./ProcessTrigger";

export const TableColumns = [
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    render: ([isProcessado, hasError]) => {
      if (isProcessado && !hasError) return <Tag color="green">PROCESSADO</Tag>;
      if (isProcessado && hasError) return <Tag color="red">ERRO</Tag>;
      return <Tag color="gold">NÃO PROCESSADO</Tag>;
    }
  },
  {
    title: "ARQUIVO",
    dataIndex: "arquivo",
    key: "arquivo"
  },
  {
    title: "DATA ARQUIVO",
    dataIndex: "dt_arquivo",
    key: "dt_arquivo"
  },
  {
    title: "DATA CADASTRO",
    dataIndex: "dt_cadastro",
    key: "dt_cadastro"
  },
  {
    title: "DATA PROCESSAMENTO",
    dataIndex: "dt_processamento",
    key: "dt_processamento"
  },
  {
    title: "RESULTADO",
    dataIndex: "resultado",
    key: "resultado",
    render: result => {
      if (result.error) {
        return (
          <div
            style={{
              maxWidth: "300px",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
            title={result.error}
          >
            <span style={{ color: "red", whiteSpace: "nowrap" }}>
              {result.error}
            </span>
          </div>
        );
      }

      const { data } = result;

      return (
        <Popover
          content={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px"
              }}
            >
              <span style={{ fontSize: "12px" }}>
                + Novas parcelas:{" "}
                <b style={{ fontSize: "12px" }}>
                  {data.resultado ? data.resultado.parcelas_novas : "---"}
                </b>
              </span>
              <span style={{ fontSize: "12px" }}>
                + Novos contratos:{" "}
                <b style={{ fontSize: "12px" }}>
                  {data.resultado ? data.resultado.operacoes_novas : "---"}
                </b>
              </span>
              <span style={{ fontSize: "12px" }}>
                + Novos devedores:{" "}
                <b style={{ fontSize: "12px" }}>
                  {data.resultado ? data.resultado.devedores_novos : "---"}
                </b>
              </span>
              <span style={{ fontSize: "12px" }}>
                - Parcelas removidas:{" "}
                <b style={{ fontSize: "12px" }}>
                  {data.resultado ? data.resultado.parcelas_removidas : "---"}
                </b>
              </span>
              <span style={{ fontSize: "12px" }}>
                - Contratos removidos:{" "}
                <b style={{ fontSize: "12px" }}>
                  {data.resultado ? data.resultado.operacoes_removidas : "---"}
                </b>
              </span>
              <span style={{ fontSize: "12px" }}>
                - Devedores removidos:{" "}
                <b style={{ fontSize: "12px" }}>
                  {data.resultado ? data.resultado.devedores_removidos : "---"}
                </b>
              </span>
            </div>
          }
        >
          <Row gutter={0} style={{ cursor: "pointer" }}>
            <Col span={12}>
              <Statistic
                value={result.added}
                precision={0}
                prefix={<Icon type="arrow-up" />}
                valueStyle={{ color: "#3f8600" }}
              />
            </Col>
            <Col span={12}>
              <Statistic
                value={result.removed}
                precision={0}
                prefix={<Icon type="arrow-down" />}
                valueStyle={{ color: "#cf1322" }}
              />
            </Col>
          </Row>
        </Popover>
      );
    }
  },
  {
    title: "AÇÕES",
    dataIndex: "acoes",
    key: "acoes",
    render: ([isProcessado, idProcess]) =>
      !isProcessado && <ProcessTrigger idProcess={idProcess} />
  }
];



// WEBPACK FOOTER //
// ./src/pages/Contratos/UploadTXT/table-columns.js